"use strict";

exports.__esModule = true;
exports["default"] = getGroupId;

function getGroupId(tournamentId, groupRef) {
  return tournamentId + "-" + groupRef;
}

module.exports = exports["default"];